import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/AuthContext';
import './Login.css';

const Login = () => {
    const { login, tokenIsValid  } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        console.log('tokenIsValid', tokenIsValid);
        if (tokenIsValid) {
            navigate('/dashboard');
        }
    });

    const handleLogin = async (e) => {
        e.preventDefault();
        const success = await login(email, password);
        if (!success) {
            setError('E-mail ou senha inválidos');
        } else {
            navigate('/dashboard');
        }
    };

    return (
        <form onSubmit={handleLogin} className='LoginForm'>
            <h2>Login</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <div className='LoginInput'>
                <Input type="email" placeholder="Seu@email" onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className='LoginInput'>
                <Input.Password
                    placeholder="Sua senha"
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>
            <button className="LoginButton" type="submit">Enviar</button>
        </form>
    );
};

export default Login;
